var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cursor-pointer",on:{"click":_vm.input}},[_c('b-icon',{class:_vm.iconClasses,attrs:{"icon":_vm.icon,"custom-size":"mdi-24px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }